import React from 'react';
import { IconWrapper } from '../runtime';
export default IconWrapper('electronic-pen', true, function (props) {
  return /*#__PURE__*/React.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 48 48",
    fill: "none"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: 'url(#' + props.id + 'd0a6105f' + ')'
  }, /*#__PURE__*/React.createElement("rect", {
    x: "35.1926",
    y: "5.32227",
    width: "12",
    height: "38",
    rx: "6",
    transform: "rotate(45 35.1926 5.32227)",
    fill: props.colors[1],
    stroke: props.colors[0],
    strokeWidth: props.strokeWidth
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 23L26 31",
    stroke: props.colors[0],
    strokeWidth: props.strokeWidth,
    strokeLinecap: props.strokeLinecap,
    strokeLinejoin: props.strokeLinejoin
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 43L12 37",
    stroke: props.colors[0],
    strokeWidth: props.strokeWidth,
    strokeLinecap: props.strokeLinecap,
    strokeLinejoin: props.strokeLinejoin
  }), /*#__PURE__*/React.createElement("rect", {
    x: "33.2681",
    y: "12.3396",
    width: "4",
    height: "4",
    rx: "2",
    transform: "rotate(30 33.2681 12.3396)",
    fill: props.colors[2]
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: props.id + 'd0a6105f'
  }, /*#__PURE__*/React.createElement("rect", {
    width: "48",
    height: "48",
    fill: props.colors[2]
  }))));
});